import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { Constants } from '../../constants/constants';
import { AwgSharedServiceService } from './awg-shared-service.service';
import { RicercaService } from './ricerca.service';

@Injectable()
export class IntegrationService {
    dataset: string;
    paramEcql: string;
    defaultExtent: any;
    layersWithEcql: any[] = [];
    layersWithEcql1: any[] = [];


    /* Indica quando tutto Almaviva WebGis Engine si è caricato */
    private finishSelectionData = new Subject<any>();
    finishSelectionData$ = this.finishSelectionData.asObservable();

    private finishNullData = new Subject<any>();
    finishNullData$ = this.finishNullData.asObservable();

    private finishFilteredData = new Subject<any>();
    finishFilteredData$ = this.finishFilteredData.asObservable();

    private evidenziaPoligono = new Subject<any>();
    evidenziaPoligono$ = this.evidenziaPoligono.asObservable();

    private changeCurrentView = new Subject<any>();
    changeCurrentView$ = this.changeCurrentView.asObservable();

    constructor(private awgSharedService: AwgSharedServiceService,private rs : RicercaService,
        @Inject(APP_CONFIG) private config: IAppConfig) { }


    // Type : SELECTION || FILTER || NULL 
    setGeoFilters(type: string, layers: any[], extent?: any[],feature?:any[],coordinate?:any[]) {



        if (type == Constants.GEO_FILTER_TYPE_FILTER) {
            //EXTENT di default oppure parametro della funzione
            this.defaultExtent = this.awgSharedService.defaultExtent;

            if (extent) {
                this.defaultExtent = extent;
            }

            this.layersWithEcql = (layers && layers.length > 0) ? this.getLayerEcql(layers,feature,coordinate) : [];

            let obj = {
                layers: this.layersWithEcql,
                extent: this.defaultExtent
            }

            this.finishFilteredData.next(obj);

        }
    }
    // Type : SELECTION || FILTER || NULL 
    evidenziaMappa(coordinate:any[]) {
        let puntiCoordinate :Array<any>;
        if(coordinate){ coordinate.map(campo => {
            
            if(campo.multipoligono.length>0){
             //var multipoligono=JSON.parse(campo.multipoligono);
             puntiCoordinate=campo.multipoligono;
            }
            }
            );}
            let obj = {
                coordinate: puntiCoordinate,
            }
            this.evidenziaPoligono.next(obj);

    }
    rimuoviPoligono() {
        let puntiCoordinate :Array<any>;
            let obj = {
                coordinate: puntiCoordinate,
            }
            this.evidenziaPoligono.next(obj);

    }
    setGeoFilters2(type: string, layers: any[],layersExtent: any[], extent?: any[]) {
            //EXTENT di default oppure parametro della funzione
            this.defaultExtent = this.awgSharedService.defaultExtent;

            if (extent) {
                this.defaultExtent = extent;
            }

           // this.layersWithEcql = this.getLayerEcql(layers);
            let obj = {
                layers: this.layersWithEcql,
                extent: this.defaultExtent
            }
            //this.layersWithEcql1 = this.getLayerEcql(layers);
            let obj1 = {
                layers: this.layersWithEcql1,
                extent: this.defaultExtent
            }

            this.finishFilteredData.next(obj);

            this.finishSelectionData.next(obj1);

    }
    setGeoFilters3(type: string, layers: any[], extent?: any[],feature?:any[]) {
        //EXTENT di default oppure parametro della funzione
        this.defaultExtent = this.awgSharedService.defaultExtent;

        if (extent) {
            this.defaultExtent = extent;
        }

    this.layersWithEcql = this.getLayerEcql(layers,feature);
        let obj = {
            layers: this.layersWithEcql,
            extent: this.defaultExtent
        }

        this.finishSelectionData.next(obj);

}

    getLayerEcql(layers,feature,coordinate?:any[]) {
        let layersWithEcql: any[] = [];
        layers.map(layer => {
            let ecql: string[] = [];
            layer.filter.map(field => {
                if(field.ids && field.ids.length){
                    let stringa=" in ('" + field.ids + "'))";
                    //alert(stringa.replace(new RegExp(",","g"),"','"));
                    ecql.push("(" + field.fieldName + stringa.replace(new RegExp(",","g"),"','"));//per mettere virgolette nel caso di ids char, 
                }
            });
            if(layer.ecql){
                ecql.push(layer.ecql);
            }
            let puntiCluster :Array<any>;
           if(feature){ feature.map(campo => {
                if(campo.layerName==layer.layerName)
                puntiCluster=campo.punticluster;
            }
           );}
           let puntiCoordinate :Array<any>;
           if(coordinate){ coordinate.map(campo => {
            if(campo.layerName==layer.layerName){
                var multipoligono=JSON.parse(campo.multipoligono);
                puntiCoordinate=multipoligono.coordinates;
            }
        }
       );}
            layer =
                {
                    layerName: layer.layerName,
                    ecql: ecql.join(" AND "),
                    feature: puntiCluster,
                    coordinate:puntiCoordinate
                }
            layersWithEcql.push(layer)
        });
        return layersWithEcql;
    }
    

    changeCurrentView2(){
        this.changeCurrentView.next();
        
    }
}
